import { render } from "./mainFrame.vue?vue&type=template&id=daa47450"
import script from "./mainFrame.vue?vue&type=script&lang=js"
export * from "./mainFrame.vue?vue&type=script&lang=js"

import "./mainFrame.vue?vue&type=style&index=0&id=daa47450&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__